<script lang="ts">
	import type { Document } from "../../../core/schema/Document.js";
	import translations from "./DocumentsShowMore.translations.json";
	import { getTranslate } from "../utils/getTranslate.js";
	import { createEventDispatcher } from "svelte";

	export let showMore: boolean | undefined;
	export let documents: Document[];
	export let beforeShowMoreAmount: number;

	const translate = getTranslate(translations);
	const dispatch = createEventDispatcher();
</script>

{#if !showMore && documents.length > beforeShowMoreAmount}
	<button
		class="text-primary lg:text-2md flex w-full justify-between p-11 text-[1.125rem]"
		on:click={() => {
			dispatch("toggle");
		}}
	>
		<span class="font-bold">{translate("showMore")}</span>
		<span class="w-[3.75rem]">+</span>
	</button>
{/if}
